import assertNever from 'assert-never';
import React from 'react';

import { GetDocumentToImportQuery, GoogleDocErrorCode } from '../../../../graphql/gen/types';

type Props = {
  data: GetDocumentToImportQuery;
};

export const GetDocumentToImportErrorView = ({ data }: Props): React.ReactElement | null => {
  if (data.linkMetadata.details.__typename === 'InvalidLink') {
    return <div>Not a valid link</div>;
  }
  if (data.linkMetadata.details.__typename !== 'GoogleDocLinkMetadata') {
    return <div>Not a Google Document link</div>;
  }

  if (data.linkMetadata.details.document?.__typename === 'GoogleDocError') {
    switch (data.linkMetadata.details.document.code) {
      case GoogleDocErrorCode.AccessDenied: {
        return <div>Cannot access this Google document</div>;
      }
      case GoogleDocErrorCode.DocumentContentParseFailed: {
        return <div>Failed to parse document content</div>;
      }
      case GoogleDocErrorCode.GoogleDocsConnectionNotEnabled: {
        return <div>You must enable GSuite Integration to access this feature.</div>;
      }
      default: {
        assertNever(data.linkMetadata.details.document.code);
      }
    }
  }

  return null;
};
